module.exports = ['ngToastProvider', function(ngToastProvider) {
    ngToastProvider.configure({
        animation: 'slide' // or 'fade'
    });
}];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/configs/NgToastProvider.js
// module id = 309
// module chunks = 0